import React from "react";

const Table = (props) => {
  const { tableHeaders = [], tableRows = [] } = props;
  const classNames = tableHeaders.map((item) => item.className);
  return (
    <div className="sim-table table-responsive">
      <table className="table">
        <thead>
          <tr>
            {tableHeaders.map((header, i) => (
              <th key={i} className={header.className}>
                {header.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row?.cellData.map((item, cellIndex) => (
                <td key={cellIndex} className={`${item.className} ${classNames[cellIndex]}`}>
                  {item.value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
